import React from "react";
import { BaseEdge, EdgeLabelRenderer, getBezierPath, EdgeProps } from "reactflow";
import closeIcon from "../assets/node/close.png";

interface CustomEdgeProps extends EdgeProps {
  data?: {
    onDelete?: (id: string) => void;
  };
}

export default function CustomEdge({ id, sourceX, sourceY, targetX, targetY, markerEnd, data }: CustomEdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} />

      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
          }}
          className="nodrag nopan"
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (data?.onDelete) data.onDelete(id);
            }}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <img src={closeIcon} width={15} alt="delete" />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
